import {API} from '../types';

interface Params {
  email: string;
}

interface Response {
  success: boolean;
}

export function authSendConfirmEmailAPI(params: Params): API<Response> {
  return {
    getData: async client => {
      const {data} = await client({
        url: '/auth/send-email-confirmation',
        method: 'POST',
        data: params,
      });
      return {data: data};
    },
    getMockData: () => {
      return {success: true};
    },
  };
}
